import config from './config';
import defaultConfig from './defaultConfig';

export default Object.assign({}, defaultConfig, config);
